import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";

import Nav from "./components/Nav";
import Sidebar from "./components/Sidebar";
import Hero from "./components/Hero";
import Expertise from "./components/Expertise";
import Projects from "./components/Projects";
import GithubContributions from "./components/GithubContributions";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Footer from "./components/Footer";
import SpokProject from "./components/SpokProject";
import TelloProject from "./components/TelloProject";
import ChatMoovProject from "./components/ChatMoovProject";
import HriEthicsProject from "./components/HriEthicsProject";
import PokemonRecommenderProject from "./components/PokemonRecommenderProject";
import { useReveal } from "./hooks/useReveal";

const Portfolio = () => {
  useReveal();

  return (
    <>
      <Nav />
      <div className="page">
        <Sidebar />
        <main>
          <Hero />
          <Expertise />
          <Experience />
          <Education />
          <Projects />
          <GithubContributions />
        </main>
      </div>
      <Footer />
      <Analytics />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/projects/spok" element={<SpokProject />} />
        <Route path="/projects/tello" element={<TelloProject />} />
        <Route path="/projects/chatmoov" element={<ChatMoovProject />} />
        <Route path="/projects/hri" element={<HriEthicsProject />} />
        <Route path="/projects/pokemon" element={<PokemonRecommenderProject />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
